// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { WidgetBarOutput, WidgetChartTypeEnum } from 'thehive-sdk';
import { BarForm, BarValues } from './BarForm';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';

export const getNewBarWidget = (bar: BarValues): WidgetBarOutput => {
    const {
        title,
        interval,
        entity,
        dateField,
        category,
        stacked = false,
        filters = [],
        periodDateField,
        log,
        customize,
    } = bar;

    return {
        type: WidgetChartTypeEnum.bar,
        options: {
            title,
            entity,
            dateField,
            interval,
            field: category,
            query: {},
            names: {},
            stacked,
            filters,
            periodDateField,
            log,
            customize,
        },
        id: '',
    };
};

const NewBarDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewBarWidget(values as BarValues)}
        WidgetForm={BarForm}
        widgetType="bar"
    />
);

export default NewBarDrawer;
